import { render, staticRenderFns } from "./OpzioniLavorazioniComandi.vue?vue&type=template&id=24d9c8ef"
import script from "./OpzioniLavorazioniComandi.vue?vue&type=script&lang=ts"
export * from "./OpzioniLavorazioniComandi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d9c8ef')) {
      api.createRecord('24d9c8ef', component.options)
    } else {
      api.reload('24d9c8ef', component.options)
    }
    module.hot.accept("./OpzioniLavorazioniComandi.vue?vue&type=template&id=24d9c8ef", function () {
      api.rerender('24d9c8ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniLavorazioniComandi.vue"
export default component.exports